import React, { Component } from 'react';
import './style.scss';
import Center from 'app/shared/modules/Center';
import Row from 'app/shared/core/Row';
import Title from 'app/shared/modules/Title';

type PromptEmailSentProps = {
  email?: string;
};

class PromptEmailSent extends Component<PromptEmailSentProps> {
  render() {
    return (
      <div className="PromptEmailSent">
        <Center>
          <Title size="lg">Check your email!</Title>
          <div className="modal-body">
            <Row>We sent an email to </Row>
            <div className="freepass-email"> {this.props.email} </div>
            <Row>Open the message and click on the link to sign in.</Row>
          </div>
        </Center>
      </div>
    );
  }
}

export default PromptEmailSent;
